import styles from './ResumeButton.module.scss';
import libraryStyles from '../../SCSS/LibraryCard.module.scss';
import { showRightArrowWhiteIcon } from '../../core/core';

const ResumeButton = ({ percentComplete, ...otherProps }) => (
  <div className={styles.resumeButton}>
    <button type='button' {...otherProps}>
      Resume&nbsp;{showRightArrowWhiteIcon()}
    </button>
    <div className={`${libraryStyles.LibraryCard} ${libraryStyles.unitPercentComplete}`}>
      {percentComplete}%&nbsp;Complete
    </div>
  </div>
);

export default ResumeButton;
